import Box from '@mui/material/Box';
import { useRetryFailedQueries } from '../../hooks/use-retry-failed-queries';
import { SectionErrorScreen } from '../alliance/system-screens';

/**
 * A section (tab, drawer, panel) whose data didn't load: the compact
 * "This section didn't load." with Try again, which refetches only the
 * failed queries. The rest of the page stays put.
 *
 * @param onRetry - Custom retry; defaults to refetching failed queries
 * @param dense - Inside a drawer
 */
export function RouteError(props: { onRetry?: () => void; dense?: boolean }) {
  // Hooks
  const retryFailed = useRetryFailedQueries();

  return (
    <Box sx={{ p: 2 }}>
      <SectionErrorScreen
        onRetry={props.onRetry || retryFailed}
        dense={props.dense}
      />
    </Box>
  );
}
